// Firebase SDK - Modular v9+ syntax
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCSUj2YVFcf6HvUFMWlkqZHS-J48i3KfTU",
  authDomain: "velvynote-40e43.firebaseapp.com",
  projectId: "velvynote-40e43",
  storageBucket: "velvynote-40e43.firebasestorage.app",
  messagingSenderId: "800075600474",
  appId: "1:800075600474:web:e36cd78bcb27f0e6323e63",
  measurementId: "G-8RXKCFCDFF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const analytics = getAnalytics(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Export for use in other components
export { app, analytics, auth, storage };